let API_URL = "https://passion-planner-api.herokuapp.com/api/download";
// let API_URL = "http://localhost:4000/api/download"

/**
 * Send an AJAX request to https://passion-planner-api.herokuapp.com to trigger an email
 *
 * @param   {string}  email  email address
 * @param   {string}  file   bit.ly URL
 *
 * @return  {string}         Response from API
 */
let downloadFile = async (email, file, product_id, product_title) => {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: API_URL,
      type: "GET",
      data: {
        email: email,
        file_path: file,
        product_id: product_id,
        product_title: product_title,
      },
      success: function (data) {
        resolve(data);
      },
      error: function (error) {
        reject(error);
      },
    });
  });
};

/**
 * Create a new dataLayer with the downloadFile event
 *
 * @param   {string}  email  email address
 * @param   {string}  file   bit.ly URL
 * @param   {integer}  product_id   Unique ID of the Shopify Product
 * @param   {string}  product_title  Unique Title of the Shopify Product
 *
 * @return  {void}
 */
let pushToGTM = (email, file, product_id, product_title) => {
  window.dataLayer = window.dataLayer || [];

  dataLayer.push({
    event: "downloadFile",
    file: file,
    email: email,
    product_id: product_id,
    product_title: product_title,
  });
};

/**
 * Update download button data attributes when variant changes
 */
let updateDownloadButton = (variantId, variantMetafields) => {
  let downloadLink = $(".downloadLink");
  let downloadSection = downloadLink.closest("div");

  if (downloadLink.length && variantMetafields && variantMetafields.file_url) {
    let productTitle =
      $("[data-product-title]").attr("data-product-title") ||
      $("h1.product-title").text() ||
      "";

    downloadLink.attr("data-file", variantMetafields.file_url);
    downloadLink.attr("data-product-id", variantId);
    downloadLink.attr(
      "data-product-title",
      productTitle.trim() + " - " + variantMetafields.title.trim()
    );
    downloadSection.show();

    console.log("Updated download button:", {
      "data-file": variantMetafields.file_url,
      "data-product-id": variantId,
      "data-product-title":
        productTitle.trim() + " - " + variantMetafields.title.trim(),
    });
  } else {
    downloadSection.hide();
    console.log(
      "Hiding download section - no file_url for variant:",
      variantId
    );
  }
};

/**
 * Get current variant ID from form
 */
let getCurrentVariantId = () => {
  return $('input[name="id"]').val();
};

let lastVariantId = null;

/**
 * Format product title nicely for customer email
 */
let formatProductTitle = (productTitle, variantTitle) => {
  // Clean up escaped quotes and format nicely
  let cleanVariantTitle = variantTitle.replace(/\\"/g, '"').trim();
  let cleanProductTitle = productTitle.trim();

  // Decode HTML entities (like &quot; to ")
  let decodedVariantTitle = cleanVariantTitle
    .replace(/&quot;/g, '"')
    .replace(/&amp;/g, "&")
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">");

  // Format: "Product Name - Variant Title"
  return `${cleanProductTitle} - ${decodedVariantTitle}`;
};

$(document).ready(() => {
  console.log("Download feature loaded");

  // Function to update download button based on URL variant parameter
  function updateDownloadButtonFromURL() {
    // Get variant ID from URL parameter
    let urlParams = new URLSearchParams(window.location.search);
    let variantId = urlParams.get("variant");

    // If no variant parameter, use the first variant
    if (!variantId && window.variantMetafields) {
      let firstVariantId = Object.keys(window.variantMetafields)[0];
      if (firstVariantId) {
        variantId = firstVariantId;
      }
    }

    if (
      variantId &&
      window.variantMetafields &&
      window.variantMetafields[variantId]
    ) {
      let metafields = window.variantMetafields[variantId];

      if (metafields.file_url) {
        // Update button attributes
        $(".downloadLink").attr("data-file", metafields.file_url);
        $(".downloadLink").attr("data-product-id", variantId);

        // Format title nicely for display
        let formattedTitle = formatProductTitle(
          $("h1.product-title").text(),
          metafields.title
        );
        $(".downloadLink").attr("data-product-title", formattedTitle);
      }
    } else {
      if (variantId) {
        console.log("Sending just Variant");
        $(".downloadLink").attr("data-product-id", variantId);
        
      } else {

        console.log("No variant parameter or no metafields found");
      }
    }
  }

  // Update on page load
  updateDownloadButtonFromURL();

  // Listen for URL changes (when variants are selected)
  $(window).on("popstate", updateDownloadButtonFromURL);

  // Also listen for form changes as backup
  $(document).on("change", 'input[type="radio"], select', function () {
    setTimeout(updateDownloadButtonFromURL, 100); // Small delay to let URL update
  });

  // Download button click
  $(".downloadLink").click(async function (e) {
    e.preventDefault();

    let $button = $(this);
    let originalText = $button.text();

    // Don't allow multiple clicks
    if ($button.hasClass("loading") || $button.prop("disabled")) {
      return;
    }

    let file = $button.attr("data-file");
    let product_id = $button.attr("data-product-id");
    let product_title = $button.attr("data-product-title");
    let email = $("#downloadEmail").val();

    if (email) {
      // Show loading state
      $button.addClass("loading").prop("disabled", true);
      $button.html('<span class="spinner"></span> Sending...');

      try {
        await downloadFile(email, file, product_id, product_title);

        // Show success state
        $button.removeClass("loading").text("Email Sent");

        // Push to GTM
        pushToGTM(email, file, product_id, product_title);

        // Show "Want to download another?" message
        let $downloadSection = $button.closest("div");
        if (!$downloadSection.find(".download-another").length) {
          $downloadSection.append(
            '<span class="download-another">Want to download another?</span>'
          );
        }
      } catch (error) {
        console.error("Download failed:", error);

        // Show error state
        $button
          .removeClass("loading")
          .prop("disabled", false)
          .text("Error - Try Again");

        // Show "Want to download another?" message
        let $downloadSection = $button.closest("div");
        if (!$downloadSection.find(".download-another").length) {
          $downloadSection.append(
            '<span class="download-another">Want to download another?</span>'
          );
        }
      }
    }
  });

  // Handle "Want to download another?" click
  $(document).on("click", ".download-another", function () {
    let $button = $(".downloadLink");
    let $downloadSection = $button.closest("div");

    // Reset button
    $button.prop("disabled", false).text("Download");

    // Remove the message
    $(this).remove();

    // Clear the email input
    $("#downloadEmail").val("").focus();
  });
});
